import { IClassname } from '@/lib/shared/model/classname';

export const Sunbed = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14261_353)">
        <path
          d="M23.4899 9.80811C23.6832 9.74109 23.8577 9.62861 23.9985 9.48014C24.1393 9.33168 24.2425 9.15156 24.2992 8.95494C24.3559 8.75832 24.3646 8.55095 24.3245 8.35028C24.2844 8.14961 24.1967 7.9615 24.0688 7.80178C22.4185 5.73527 20.1677 4.23165 17.6269 3.49827C15.086 2.76489 12.3801 2.83788 9.8825 3.70716C7.38485 4.57644 5.21841 6.19921 3.68193 8.35167C2.14544 10.5041 1.3146 13.0803 1.30397 15.7249C1.30301 15.9293 1.35113 16.131 1.44427 16.313C1.53741 16.495 1.67286 16.652 1.83925 16.7708C2.00563 16.8896 2.1981 16.9668 2.40048 16.9958C2.60286 17.0248 2.80925 17.0049 3.00232 16.9376L23.4899 9.80811Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.88652 3.7177L9.04565 1.30371"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2461 13.373L14.8154 17.8815"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3149 26.4658C21.1957 26.5909 21.0523 26.6905 20.8935 26.7586C20.7347 26.8267 20.5638 26.8618 20.391 26.862H3.8803C3.20245 26.862 2.55236 26.5927 2.07305 26.1134C1.59374 25.6341 1.32446 24.984 1.32446 24.3061C1.32446 23.6283 1.59374 22.9782 2.07305 22.4989C2.55236 22.0196 3.20245 21.7503 3.8803 21.7503H18.2147C18.3899 21.7502 18.5633 21.7141 18.724 21.6442C18.8847 21.5743 19.0293 21.4721 19.1488 21.3439L26.1991 15.1537C26.4326 14.9053 26.7128 14.7054 27.0236 14.5653C27.3344 14.4252 27.6697 14.3477 28.0105 14.3372C28.3512 14.3267 28.6907 14.3834 29.0095 14.5041C29.3283 14.6248 29.6203 14.8071 29.8686 15.0406C30.117 15.2741 30.317 15.5543 30.4571 15.8651C30.5972 16.1759 30.6747 16.5112 30.6852 16.852C30.6957 17.1927 30.639 17.5322 30.5183 17.851C30.3976 18.1698 30.2153 18.4618 29.9817 18.7101L21.3149 26.4658Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.43604 30.6961L8.97142 26.8623"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7174 30.6961L19.1948 26.8623"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14261_353">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
